export default __webpack_public_path__ + "media/images/logos/wordmark_dark-111b890dc05c9b9f3abdcc794563b07d.png";